import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _callSuper from "@babel/runtime/helpers/esm/callSuper";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@instructure/ui-text';
import { Flex } from '@instructure/ui-flex';
import { View } from '@instructure/ui-view';
import { Spinner } from '@instructure/ui-spinner';
import isEqual from 'lodash/isEqual';
import t from 'format-message';
import OutcomeCheckbox from "../OutcomeCheckbox/index.js";
import AlignmentItem from "../AlignmentItem/index.js";
import Pagination from "../Pagination/index.js";
export var RESULTS_PER_PAGE = 10;
var SearchResults = /*#__PURE__*/function (_React$Component) {
  function SearchResults() {
    _classCallCheck(this, SearchResults);
    return _callSuper(this, SearchResults, arguments);
  }
  _inherits(SearchResults, _React$Component);
  return _createClass(SearchResults, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        isSearchLoading = _this$props.isSearchLoading,
        searchPage = _this$props.searchPage,
        screenreaderNotification = _this$props.screenreaderNotification;
      if (screenreaderNotification) {
        if (!isSearchLoading && prevProps.isSearchLoading) {
          screenreaderNotification(t('Results updated for page {page} of {totalPages}', {
            page: searchPage,
            totalPages: this.getPageCount()
          }));
          screenreaderNotification(this.getResultCountText());
        }
        if (!isEqual(searchPage, prevProps.searchPage)) {
          screenreaderNotification(t('Loading page {page}', {
            page: searchPage
          }));
        }
      }
    }
  }, {
    key: "renderEntries",
    value: function renderEntries() {
      var _this$props2 = this.props,
        setFocusedOutcome = _this$props2.setFocusedOutcome,
        isOutcomeSelected = _this$props2.isOutcomeSelected,
        isPicker = _this$props2.isPicker,
        selectOutcomeIds = _this$props2.selectOutcomeIds,
        deselectOutcomeIds = _this$props2.deselectOutcomeIds,
        searchEntries = _this$props2.searchEntries;
      // Filter out and null search results. This could happen if the outcome cannot be found.
      return searchEntries.filter(Boolean).map(function (outcome) {
        return /*#__PURE__*/React.createElement("div", {
          key: outcome.id,
          "data-automation": "searchResults__outcomeResult"
        }, isPicker ? /*#__PURE__*/React.createElement(OutcomeCheckbox, {
          outcome: outcome,
          setFocusedOutcome: setFocusedOutcome,
          isOutcomeSelected: isOutcomeSelected,
          selectOutcomeIds: selectOutcomeIds,
          deselectOutcomeIds: deselectOutcomeIds
        }) : /*#__PURE__*/React.createElement(AlignmentItem, {
          outcome: outcome,
          isOutcomeSelected: isOutcomeSelected,
          selectOutcomeIds: selectOutcomeIds,
          deselectOutcomeIds: deselectOutcomeIds,
          isTray: true
        }));
      });
    }
  }, {
    key: "getPageCount",
    value: function getPageCount() {
      var searchTotal = this.props.searchTotal;
      return Math.ceil(searchTotal / RESULTS_PER_PAGE);
    }
  }, {
    key: "renderPagination",
    value: function renderPagination() {
      var _this$props3 = this.props,
        searchPage = _this$props3.searchPage,
        updateSearchPage = _this$props3.updateSearchPage;
      return /*#__PURE__*/React.createElement(Pagination, {
        page: searchPage,
        updatePage: updateSearchPage,
        numPages: this.getPageCount()
      });
    }
  }, {
    key: "getResultCountText",
    value: function getResultCountText() {
      var searchTotal = this.props.searchTotal;
      return t("{\n      count, plural,\n      =0 {The search returned no results}\n      one {# result}\n      other {# results}\n    }", {
        count: searchTotal
      });
    }
  }, {
    key: "renderResults",
    value: function renderResults() {
      var searchEntries = this.props.searchEntries;
      return /*#__PURE__*/React.createElement(View, null, searchEntries.length > 0 && /*#__PURE__*/React.createElement(View, {
        "data-automation": "searchResults__resultsList",
        display: "block",
        padding: "small none none none"
      }, this.renderEntries()));
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var searchTotal = this.props.searchTotal;
      return searchTotal !== null && /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Text, {
        size: "small",
        "data-automation": "searchResults__resultsCount"
      }, this.getResultCountText()));
    }
  }, {
    key: "renderLoading",
    value: function renderLoading() {
      return /*#__PURE__*/React.createElement(Flex, {
        justifyItems: "center"
      }, /*#__PURE__*/React.createElement(Flex.Item, {
        padding: "small"
      }, /*#__PURE__*/React.createElement(Spinner, {
        renderTitle: t('Loading search results')
      })));
    }
  }, {
    key: "render",
    value: function render() {
      var isSearchLoading = this.props.isSearchLoading;
      return /*#__PURE__*/React.createElement(Flex, {
        height: "100%",
        width: "100%",
        padding: "small none none none",
        alignItems: "stretch",
        direction: "column"
      }, /*#__PURE__*/React.createElement(Flex.Item, {
        shouldGrow: true
      }, this.renderHeader(), isSearchLoading ? this.renderLoading() : this.renderResults()), /*#__PURE__*/React.createElement(Flex.Item, null, !isSearchLoading && this.renderPagination()));
    }
  }]);
  SearchResults.displayName = "SearchResults";
}(React.Component);
// eslint-disable-next-line no-undef
SearchResults.propTypes = {
  isSearchLoading: PropTypes.bool.isRequired,
  searchEntries: PropTypes.array.isRequired,
  searchPage: PropTypes.number.isRequired,
  searchTotal: PropTypes.number,
  updateSearchPage: PropTypes.func.isRequired,
  setFocusedOutcome: PropTypes.func,
  isOutcomeSelected: PropTypes.func.isRequired,
  selectOutcomeIds: PropTypes.func.isRequired,
  deselectOutcomeIds: PropTypes.func.isRequired,
  screenreaderNotification: PropTypes.func,
  isPicker: PropTypes.bool
};
SearchResults.defaultProps = {
  setFocusedOutcome: function setFocusedOutcome() {},
  screenreaderNotification: null,
  searchTotal: null,
  isPicker: false
};
export default SearchResults;